import { PureComponent } from 'react'
import { InteractionManager } from 'react-native'

import { isApp } from '@zet/utils'
import { MotiView, View } from 'moti'
import { Skeleton } from 'moti/skeleton'

import CategoryLoader from '../loader/categoryLoader'

interface ILazyHOC {
  isShimmerVisible?: boolean
  children?: React.ReactNode
  isCategory?: boolean
}
export default class LazyHOC extends PureComponent<ILazyHOC> {
  state = {
    hidden: true,
  }

  componentDidMount() {
    InteractionManager.runAfterInteractions(() => {
      setTimeout(() => {
        this.setState({ hidden: false })
      }, 50)
    })
  }

  Spacer = ({ height = 16 }) => <View style={{ height }} />

  render() {
    //Interaction Manager is having issue in OnePlus Devices
    if (this.state.hidden && isApp) {
      return this.props.isShimmerVisible ? (
        <MotiView
          transition={{
            type: 'timing',
          }}
          animate={{ backgroundColor: '#ffffff' }}
          className="mt-3 px-3"
        >
          <Skeleton colorMode={'light'} width={'100%'} />
          <this.Spacer height={8} />
          <Skeleton colorMode={'light'} width={'90%'} />
          <this.Spacer height={8} />
          <Skeleton colorMode={'light'} width={'80%'} />
          <this.Spacer height={8} />
          <Skeleton colorMode={'light'} width={'100%'} />
        </MotiView>
      ) : this.props.isCategory ? (
        <CategoryLoader />
      ) : (
        <></>
      )
    }

    return this.props.children
  }
}
